import angular from 'angular';
angular
  .module('commonServices')
  .filter('removeDuplicateSoftwares', ['translateListFilter', removeDuplicateSoftwares]);

function removeDuplicateSoftwares(translateListFilter) {
  return function(input) {
    if (!Array.isArray(input)) return input;

    // we will remove the dupes based on the translation, because the link is not available and Yuki can for example be filled out in both accounting software and receive invoice software.
    const translations = input.map(x => getTranslation(x.type, x.metadata, translateListFilter));
    const indicesToRemove = [];
    const set = new Set();

    translations.forEach((element, index) => {
      if (element !== '' && set.has(element)) {
        indicesToRemove.push(index);
      } else {
        set.add(element);
      }
    });

    // loop over backwards because when we remove an item using splice, the indexes will shift and we will remove an entry that wasnt a dupe
    indicesToRemove.sort((a, b) => b - a);
    indicesToRemove.forEach(index => {
      input.splice(index, 1);
    });
    return input;
  };
}

const getTranslation = (type, softwareValue, translateListFilter) => {
  if (type === 6) return translateListFilter(softwareValue, 'SocialSecretariat', '');
  if (type === 7) return translateListFilter(softwareValue, 'SocialSecurityFund', '');
  if (type === 10) return translateListFilter(softwareValue, 'AccountingSoftware', '');
  if (type === 11) return translateListFilter(softwareValue, 'OtherSoftware', '');
  if (type === 17) return translateListFilter(softwareValue, 'sendInvoiceSoftware', '');
  if (type === 18) return translateListFilter(softwareValue, 'receiveInvoiceSoftware', '');

  return '';
};
